import React from 'react';
import NewKanbanColumn from './NewKanbanColumn';

function NewKanbanBoard({ columns, columnCards, columnSummaries, kanbanReady, loadMoreColumnCards, canViewValue, showValues, cardActions, density }) {
  if (!columns.length && kanbanReady) {
    return <div className="new-home-board-empty"><strong>Nenhuma etapa disponível</strong><span>Revise o funil e os filtros selecionados.</span></div>;
  }

  return (
    <main className="new-home-board" aria-label="Quadro Kanban">
      <div className="new-home-board-track">
        {columns.map((column) => (
          <NewKanbanColumn
            key={column.id}
            column={column}
            columnData={columnCards[column.id]}
            summary={columnSummaries.find((item) => Number(item.column_id) === Number(column.id))}
            kanbanReady={kanbanReady}
            loadMoreColumnCards={loadMoreColumnCards}
            canViewValue={canViewValue}
            showValues={showValues}
            cardActions={cardActions}
            density={density}
          />
        ))}
      </div>
    </main>
  );
}

export default React.memo(NewKanbanBoard);
